import dayjs from 'dayjs';

import {
  COMMON_REQUEST_DATE_FORMAT,
  WEEKDAY_MONTH_DAY_FORMAT,
  WEEKDAY_MONTH_DAY_YEAR_FORMAT,
} from 'constants/date';

import { getMessageSender, getMessageTimestamp, isSystemMessage } from '../TeamChat.utils';

import { GROUP_WINDOW_MS } from './TeamChatMessageList.constants';

export const isMessageGroupedWithPrevious = (message, previousMessage) => {
  if (!previousMessage || isSystemMessage(previousMessage) || isSystemMessage(message)) {
    return false;
  }

  const currentSender = getMessageSender(message);
  const previousSender = getMessageSender(previousMessage);

  if (!currentSender.userId || currentSender.userId !== previousSender.userId) {
    return false;
  }

  const currentTimestamp = getMessageTimestamp(message);
  const previousTimestamp = getMessageTimestamp(previousMessage);

  if (!currentTimestamp || !previousTimestamp) {
    return false;
  }

  const delta = new Date(currentTimestamp).getTime() - new Date(previousTimestamp).getTime();

  return delta >= 0 && delta <= GROUP_WINDOW_MS;
};

export const getMessageDateKey = message => {
  const timestamp = getMessageTimestamp(message);

  if (!timestamp) {
    return null;
  }

  const date = dayjs(timestamp);

  if (!date.isValid()) {
    return null;
  }

  return date.format(COMMON_REQUEST_DATE_FORMAT);
};

export const formatMessageDateLabel = dateKey => {
  if (!dateKey) {
    return '';
  }

  const date = dayjs(dateKey);

  if (!date.isValid()) {
    return '';
  }

  const now = dayjs();

  if (date.isSame(now, 'day')) {
    return 'Today';
  }

  if (date.isSame(now.subtract(1, 'day'), 'day')) {
    return 'Yesterday';
  }

  if (date.isSame(now, 'year')) {
    return date.format(WEEKDAY_MONTH_DAY_FORMAT);
  }

  return date.format(WEEKDAY_MONTH_DAY_YEAR_FORMAT);
};
